import { render, staticRenderFns } from "./ClientBilling.vue?vue&type=template&id=39629674&scoped=true&"
import script from "./ClientBilling.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClientBilling.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClientBilling.vue?vue&type=style&index=0&id=39629674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39629674",
  null
  
)

export default component.exports